import { createAction, props } from "@ngrx/store";
import { Division } from "../../models/division";

/*CRUD CATALOG DIVISION*/
export const getAllDivisionsCatalogAct = createAction('getAllDivisionCatalogEffect');
export const loadAllDivisionsCatalogAct = createAction('loadAllDivisionCatalogEffect', props<{ divisions: Division[] }>());

export const findDivisionAct = createAction('findDivisionEffect', props <{ id: number }>());
export const loadDivisionByIdAct = createAction('loadDivisionByIdEffect', props<{ division: Division }>());

export const saveDivisionAct = createAction('saveDivisionEffect', props<{ divisionNew: Division }>());
export const saveSuccessDivisionAct = createAction('saveSuccessDivisionEffect', props<{ divisionNew: Division }>());

export const updateDivisionAct = createAction('updateDivisionEffect', props<{ divisionUpdated: Division }>());
export const updateSuccessDivisionAct = createAction('updateSuccessDivisionEffect', props<{ divisionUpdated: Division }>());
/*CRUD CATALOG DIVISION END*/
export const setViolationsDivisionAct = createAction('setViolationsDivisionEffect', props<{ divisionForm: Division, violations: {} }>());

export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );